<template>
    <div class="content" :style="'background:' + skin.main_color_1">
        <div class="right d-flex justify-content-between">
            <div class="left" style="height: 5vh; width: 10%;margin-bottom: 5px;margin-top: 5px;"
                v-if="screen_width >= 1400">
                <div v-if="skin.header_desktop.logo">
                    <img style="height:100%;width: 100%;" :src="skin.header_desktop.logo" alt="">
                </div>
            </div>
            <div class="left" style="height: 5vh; width: 20%;margin-bottom: 5px;margin-top: 5px;"
                v-if="screen_width >= 769 && screen_width <= 1399">
                <div v-if="skin.header_desktop.logo">
                    <img style="height:50%;width: 60%; object-fit:cover;" :src="skin.header_desktop.logo" alt="">
                </div>
            </div>
            <div class="left" style="height: 5vh; width: 30%;margin-bottom: 5px;margin-top: 5px;"
                v-if="screen_width <= 768">
                <div v-if="skin.header_desktop.logo">
                    <img style="height:100%;width: 100%;" :src="skin.header_mobil.logo" alt="">
                </div>
            </div>
            <div class="d-flex gap-3" style="display: flex; align-items: center;">
                <div class="deposito-logged" v-if="user.token">
                    <div class="deposito-container">
                        <!-- <button><i class="fa-solid fa-comment-dollar"></i> DEPOSITO</button> -->
                    </div>
                </div>
                <div class="saldo-logged" v-if="user.token">
                    <div class="saldo-container">
                        <span>{{ balance.saldo }} $</span>
                    </div>
                </div>
                <div class="user-logo-logged" v-if="user.token" @click="openMyAccountModal">
                    <div class="user-logo-container">
                        <i class="fa-solid fa-circle-user"></i>
                    </div>
                </div>
                <div v-if="!user.token" class="login-register d-flex gap-3 auth" style="font-size: 12px;">
                    <div @click="loginUpperHeader" class="login">
                        {{ translate('log_in') }}
                    </div>
                    <div @click="registerUpperHeader" :style="'background:' + skin.main_active_1" class="register">
                        {{ translate('sign_in') }}
                    </div>
                </div>
                <div class="lang" @click="clickEventLang">
                    <languageSelector v-bind:skin="skin" v-bind:language="language" :angle-row-prop="angleRow"
                        @update-angle-row="updateAngleRow">
                    </languageSelector>
                </div>
                <div class="time-container">
                    <div class="time" style="font-size: 12px;">
                        {{ time }}
                    </div>
                </div>
                <div :class="['options', { 'invert': isInvert }]">
                    <button @click="displayOptions">
                        <div ref="optionsButton">
                            <i v-if="displayOptionsFlag === true" class="fa-solid fa-ellipsis-vertical"></i>
                            <i v-if="displayOptionsFlag === false" class="fa-solid fa-ellipsis"></i>
                        </div>
                    </button>
                    <div class="triangle" v-if="menuVisible"></div>
                    <div v-if="menuVisible" class="minu" :style="'background:' + skin.main_color_1">
                        <ul>
                            <!-- <li v-if="user.token !== ''"><i class="fa-solid fa-rotate-left"></i></li>
                            <li><i class="fa-solid fa-bell"></i></li>
                            <li><i class="fa-solid fa-star"></i></li>
                            <li v-if="user.token !== ''"><i class="fa-solid fa-envelope"></i></li>
                            <li v-if="user.token !== ''"><i class="fa-solid fa-bag-shopping"></i></li>
                            <li><i class="fa-solid fa-gear"></i></li> -->
                            <li @click="logout()"><i class="fa-solid fa-power-off"></i></li>
                            <!-- <li class="lock" style="opacity: 0.5;"><i class="fa-solid fa-file-lines"></i></li> -->
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import languageSelector from './language.vue'
export default {
    name: 'UpperHeader',
    props: ['skin', 'language', 'translation'],
    components: {
        languageSelector
    },
    data() {
        return {
            time: '',
            displayOptionsFlag: true,
            menuVisible: false,
            isInvert: false,
            angleRow: false,
            balance: {
                saldo: 0,
                conversion: 0
            },
            screen_width: 0,
        }
    },
    methods: {
        openMyAccountModal() {
            this.$root.$emit('open-my-account-modal'); // Emite un evento para abrir el modal
        },
        logout() {
            this.$store.dispatch('logOut');
            // this.$root.$emit('forceRender');
        },
        sizeControl() {
            this.screen_width = window.innerWidth;
        },
        clickEventLang() {
            this.angleRow = !this.angleRow;
        },
        updateAngleRow(newValue) {
            this.angleRow = newValue;
        },
        loginUpperHeader() {
            this.$emit('login-upper-header');
        },
        registerUpperHeader() {
            this.$emit('register-upper-header');
        },
        updaeClock() {
            const now = new Date();
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
            const seconds = String(now.getSeconds()).padStart(2, '0');
            this.time = `${hours}:${minutes}:${seconds}`;
        },
        displayOptions() {
            const optionsButton = this.$refs.optionsButton;
            if (this.displayOptionsFlag) {
                optionsButton.classList.remove('rotate-left');
                optionsButton.classList.add('rotate-right');
            } else {
                optionsButton.classList.remove('rotate-right');
                optionsButton.classList.add('rotate-left');
            }
            this.isInvert = !this.isInvert;
            this.displayOptionsFlag = !this.displayOptionsFlag;
            this.menuVisible = !this.menuVisible;
        },
        translate(text) {
            if (text) {
                if (this.$props.translation[text]) {
                    return this.$props.translation[text][this.$props.language];
                }
                else {
                    var new_text_serched = text.replace(/ /g, "_");
                    if (this.$props.translation[new_text_serched]) {
                        return this.$props.translation[new_text_serched][this.$props.language];
                    }
                }
                return text;
            }
        },
        sizeControl() {
            this.screen_width = window.innerWidth; // Actualiza el ancho de la pantalla
        },
    },
    mounted() {
        this.updaeClock();
        setInterval(this.updaeClock, 1000);
        this.displayOptionsFlag;
        this.displayOptions;
        this.sizeControl();
        // Actualizar el valor cuando se redimensiona la pantalla
        window.addEventListener("resize", this.sizeControl);
    },
    computed: {
        //     hoverCss(){
        //         return {
        //             '--activeHover':this.$props.skin.main_active_1,
        //             '--activeHover2': this.$props.skin.main_active_2,
        //             '--darkHover': this.$props.skin.main_color_1
        //         }
        // },
        user() {
            let config = this.$store.getters['getConfig'];
            let data = this.$store.getters['getUserData'];
            if (data.user_data.data) {
                this.balance.saldo = config.SkinConfig.main.newbonus ? data.user_data.data.available_balance + data.user_data.data.bonus + data.user_data.data.frozen : data.user_data.data.balance;
                this.balance.conversion = data.user_data.data.balance * data.user_data.data.tasa;
            }
            return data;
        },
    }
}
</script>

<style scoped>
div {
    box-sizing: border-box;
}
.rotate-right {
    animation: rotateRight 0.24s forwards;
}

.rotate-left {
    animation: rotateLeft 0.24s forwards;
}

@keyframes rotateRight {
    from {
        transform: rotate(-45deg);
    }

    to {
        transform: rotate(0deg);
    }
}

@keyframes rotateLeft {
    from {
        transform: rotate(45deg);
    }

    to {
        transform: rotate(0deg);
    }
}

.triangle {
    position: absolute;
    top: 34px;
    right: -2px;
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid #FFFFFF1A;
    color: #FFFFFF1A;
    border-color: transparent transparent #ffffff33;
    transform: translate(-50%);
    /* El color del triángulo */
}

.minu {
    /* position: fixed;  cuando pantalla <= 768*/
    /* top: 58px;  */
    position: absolute;
    top: 41px;
    width: 50px;
    right: -7px;
    box-shadow: 0 2px 4px #00000026;
    z-index: 1;
    will-change: scroll-position;
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    border-radius: 4px;
    /* background-color: #FFFFFF1A; */
    box-shadow: 0 2px 4px #00000026;
    display: flex;

}

.minu ul {
    list-style: none;
    margin: 0;
    padding: 0;
    width: 100%;
}

.minu li {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 56px;
    font-size: 18px;
    padding: 10px;
    cursor: pointer;
    width: 100%;
}

.minu li i {
    font-size: 20px;
    color: #ffffffd9;
}

.minu li:hover i {
    color: var(--activeHover);
}

.minu li:hover {
    background: #3d454d;
}

.minu li.lock:hover i {
    color: #ffffffd9;
    cursor: default
}

.minu li.lock:hover {
    color: #ffffffd9;
    cursor: default
}

.options button {
    width: 34px;
    height: 28px;
    border: none;
    border-radius: 4px;
    color: #ffffffcc;
    /*invertido = #18242f*/
    background-color: #FFFFFF1A;
    /*invertido = ##fff9 */
}

.invert button {
    color: var(--darkHover);
    background-color: #fff9;
}

.login {
    text-decoration: underline;
    display: flex;
    align-items: center;
}

.login:hover {
    cursor: pointer;
}

.register {
    display: flex;
    align-items: center;
    padding: 0 8px;
    color: rgba(0, 0, 0, 1);
    margin-inline-start: 10px;
    margin-inline-end: 10px;
    height: 28px;
    border-radius: 4px;

}

.register:hover {
    cursor: pointer;
}

.time {
    position: relative;
    flex-shrink: 0;
    height: 28px;
    color: rgb(255, 255, 255, 1);
    /* padding: 0 10px; */
    background: #ffffff1a;
    border-radius: 4px;
    font-size: 12px;
    line-height: 28px;
}

.saldo-logged {
    font-size: 12px;
    color: #fff;
}

.user-logo-container {
    text-shadow: 0 0 12px #3493ff, 0 0 20px #3493ff;
}

.user-logo-container i {
    color: #fff9;
    font-size: 28px;
}

.auth,
.lang,
.time-container,
.options,
.deposito-logged,
.saldo-logged,
.user-logo-logged {
    position: relative;
}

.auth::after,
.lang::after,
.time-container::after,
.options::after,
.saldo-logged::after,
.user-logo-logged::after {
    left: -10px;
    content: "";
    position: absolute;
    width: 1px;
    height: 30px;
    bottom: 0;
    top: 0;
    margin: auto;
    z-index: 1;
    background: #ffffff1a;
}

@media (max-width: 536px) {

    .lang,
    .time-container,
    .deposito-logged {
        display: none;
    }

    .auth::after,
    .lang::after,
    .time-container::after,
    .options::after,
    .saldo-logged::after,
    .user-logo-logged::after {
        left: -10px;
        content: "";
        position: absolute;
        width: 0px;
        height: 30px;
        bottom: 0;
        top: 0;
        margin: auto;
        z-index: 1;
        background: #ffffff1a;
    }
}

@media (max-width: 768px) {
    .minu {
        position: fixed;
        top: 58px;
        width: 50px;
        right: -7px;
        box-shadow: 0 2px 4px #00000026;
        z-index: 1;
        will-change: scroll-position;
        overflow-x: hidden;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
        border-radius: 4px;
        background-color: #495058;
        box-shadow: 0 2px 4px #00000026;
        display: flex;

    }
}
</style>
